(function () {
  'use strict';

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function initTabs(root) {
    if (root.dataset.clHomeTabsReady === 'true') return;
    root.dataset.clHomeTabsReady = 'true';
    var tabs = all('[data-cl-home-tab]', root);
    var panels = all('[data-cl-home-panel]', root);

    function select(id) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.clHomeTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.clHomePanel !== id;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab.dataset.clHomeTab);
      });
      tab.addEventListener('keydown', function (event) {
        var index = tabs.indexOf(tab);
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (!next) return;
        event.preventDefault();
        next.focus();
        select(next.dataset.clHomeTab);
      });
    });
  }

  function initCarousels(root) {
    all('[data-cl-home-carousel]', root).forEach(function (carousel) {
      if (carousel.dataset.clHomeCarouselReady === 'true') return;
      carousel.dataset.clHomeCarouselReady = 'true';
      var frame = carousel.closest('.cl-home-picks__carousel');
      var previous = frame.querySelector('[data-cl-home-carousel-previous]');
      var next = frame.querySelector('[data-cl-home-carousel-next]');

      function move(direction) {
        var firstCard = carousel.firstElementChild;
        if (!firstCard) return;
        var gap = parseFloat(getComputedStyle(carousel).gap) || 0;
        carousel.scrollBy({
          left: direction * (firstCard.getBoundingClientRect().width + gap),
          behavior: 'smooth'
        });
      }

      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
    });
  }

  function initVideoDialog(root) {
    var trigger = root.querySelector('[data-cl-home-video]');
    var dialog = root.querySelector('[data-cl-home-video-dialog]');
    if (!trigger || !dialog || trigger.dataset.clHomeVideoReady === 'true') return;
    trigger.dataset.clHomeVideoReady = 'true';
    var video = dialog.querySelector('video');
    var close = dialog.querySelector('[data-cl-home-video-close]');

    trigger.addEventListener('click', function () {
      if (dialog.showModal) dialog.showModal();
      else dialog.setAttribute('open', '');
      if (video) video.play().catch(function () {});
    });

    function closeDialog() {
      if (dialog.close) dialog.close();
      else {
        if (video) video.pause();
        dialog.removeAttribute('open');
      }
    }

    if (close) close.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', function () {
      if (video) video.pause();
    });
  }

  function initYoutube(root) {
    var facade = root.querySelector('[data-cl-home-youtube]');
    if (!facade || facade.dataset.clHomeYoutubeReady === 'true') return;
    facade.dataset.clHomeYoutubeReady = 'true';
    var trigger = facade.querySelector('[data-cl-home-youtube-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var iframe = document.createElement('iframe');
      iframe.className = 'cl-home-youtube cl-home-youtube__iframe';
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(facade.dataset.videoId) + '?autoplay=1&rel=0&playsinline=1';
      iframe.title = trigger.getAttribute('aria-label') || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      facade.replaceWith(iframe);
      iframe.focus();
    });
  }

  function start(scope) {
    all('.cl-home-picks', scope).forEach(function (picks) {
      initTabs(picks);
      initCarousels(picks);
    });
    all('.cl-home-testimonials', scope).forEach(initVideoDialog);
    all('.cl-home-story', scope).forEach(initYoutube);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    start(event.target);
  });
})();
